// 9fbef606107a605d69c0edbcd8029e5d
import { DEFAULT_REDUCER_KEY } from '@tcp/core/src/utils/cache.util';
import CONSTANT from '../AIAssistant.constants';

const initialState = {
  [DEFAULT_REDUCER_KEY]: null,
  chatSummary: [],
  isLoading: false,
};

const AIAssistantReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANT.SET_CHAT_SUMMARY_R: {
      const chats = [...(state.chatSummary || [])];
      chats.push({ response: action.payload });
      return { ...state, chatSummary: chats };
    }
    case CONSTANT.SET_CHAT_SUMMARY_Q: {
      const chats = [...(state.chatSummary || [])];
      chats.push({ query: action.payload });
      return { ...state, chatSummary: chats };
    }
    case CONSTANT.SET_LOADING: {
      return { ...state, isLoading: action.payload };
    }
    default:
      return state;
  }
};

export default AIAssistantReducer;
